import * as React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button/Button";

import DataBox from "../../../../components/UI/DataBox";
import CurrencyNumber from "../../../../components/UI/CurrencyNumber";
import { connect } from "react-redux";

function HouseholdRecommendedPortfolio({
  classes,
  household,
  householdId,
  pathname,
  appName,
}) {
  if (household.householdDetail) {
    // If a household has not finish rror or loss sim, or it has a less than 10000 initial investment, then don't generate this default portfolio
    if (
      household.householdDetail.rror === 0 ||
      household.householdDetail.risk === 0 ||
      household.householdDetail.initialInvestment <= 10000
    ) {
      return null;
    }

    const portfolio = household.householdDetail.defaultPortfolio;
    if (portfolio) {
      return (
        <DataBox
          fields={[
            ["Portfolio Name", portfolio.name],
            [
              "Investment Amount",
              <CurrencyNumber value={portfolio.metadata.initialInvestment} />,
            ],
            ["Scenario", portfolio.metadata.displayName],
            // ['Created', formatDate(portfolio.createdAt)],
            // ['Last Modified', formatDate(portfolio.updatedAt)]
          ]}
          actions={[
            <Link
              to={
                pathname.includes("/Portal/admin/household")
                  ? `/Portal/admin/household/${householdId}/portfolio${
                      portfolio.uuid ? "/" + portfolio.uuid : ""
                    }`
                  : `/Portal/household/${householdId}/summary`
              }
            >
              <Button
                className={classes.dataBoxBtn}
                variant="outlined"
                size="small"
                color="primary"
                data-cy="household.recommended.view"
              >
                View
              </Button>
            </Link>,
          ]}
          title={`Cy Recommended Household Portfolio`}
        />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    appName: state.app.appName,
  };
};

export default connect(mapStateToProps)(HouseholdRecommendedPortfolio);



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/RecommendedPortfolio/index.jsx